module.exports = __webpack_public_path__ + "img/boiler-S-light.6bb71897.png";